


































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import LocationListFilterCity from './LocationListFilterCity.vue';
import LocationListFilterState from './LocationListFilterState.vue';
import LocationListFilterBranchType from './LocationListFilterBranchType.vue';
import LocationListFilterEnabled from './LocationListFilterEnabled.vue';

import LocationFilter from '@/types/LocationFilter';

@Component({
	components: {
		LocationListFilterCity,
		LocationListFilterState,
		LocationListFilterBranchType,
		LocationListFilterEnabled,
	}
})
export default class LocationListFilter extends Vue implements LocationFilter {
	@Prop({}) readonly filter!: LocationFilter;
	@Prop({ default: () => [] }) readonly locations!: Array<Location>;

	isBrick = false;
	hasAtm = false;
	state: Array<string> = [];
	city = '';
	enabled = '';
	locationTypes: Array<number> = [];

	get updatedFilter() {
		return {
			state: this.state,
			city: this.city,
			enabled: this.enabled,
			locationTypes: this.locationTypes
		};
	}

	set updatedFilter(filter: LocationFilter) {
		this.city = filter.city;
		this.state = filter.state;
		this.enabled = filter.enabled;
		this.locationTypes = filter.locationTypes;
	}

	created() {
		this.updatedFilter = this.filter;
	}

	absorbCity(city: string) {
		this.city = city;
		this.emitUpdates();
	}

	absorbState(state: Array<string>) {
		this.state = state;
		this.emitUpdates();
	}

	absorbEnabled(enabled: string) {
		this.enabled = enabled;
		this.emitUpdates();
	}

	emitUpdates() {
		this.$emit('update', this.updatedFilter);
	}

	reset() {
		this.isBrick = false,
		this.hasAtm = false,
		this.state = [],
		this.city = '',
		this.absorbEnabled('');
		this.locationTypes = [];
		
		this.emitUpdates();
	}

	absorbLocationTypes(types: Array<number>) {
		this.locationTypes = types;
		this.emitUpdates();
	}
}

